import React, { useContext } from 'react'
import { Link, useLocation } from "react-router-dom"
import { Menu } from 'antd'
import { getRoutes } from "./route";

// Contexts
import GlobalContext from '../../contexts/global'

// Interfaces
import { Route } from "../../interfaces/layouts/dashboard";

export default function Index({ collapsed = false, setCollapsed }: { collapsed?: boolean, setCollapsed?: (collapsed: boolean) => void }) {

    const { user } = useContext(GlobalContext)
    const location = useLocation()
    const routes = [...getRoutes(user)];
    const getItems = (routes: Route[]) => {
        for (let i = 0; i < routes.length; i++) {
            if (routes[i].menu) {
                routes[i] = {
                    ...routes[i],
                    label: routes[i].children ? routes[i].label : <Link to={routes[i].key}>{routes[i].label}</Link>,
                    menu: undefined,
                }
                getItems(routes[i].children || [])
            } else delete routes[i];
        }
        return routes;
    }

    return (
        <Menu
            theme="light"
            mode="inline"
            defaultSelectedKeys={['/']}
            defaultOpenKeys={[`/${location.pathname.split('/')[1]}`]}
            selectedKeys={[location.pathname]}
            onSelect={() => setCollapsed && setCollapsed(!collapsed)}
            items={getItems(routes)}
        />
    )
}
